import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var VersionUtils = /*#__PURE__*/function () {
  function VersionUtils() {
    _classCallCheck(this, VersionUtils);
  }
  _createClass(VersionUtils, null, [{
    key: "isGreaterOrEqual",
    value: function isGreaterOrEqual(version, targetVersion) {
      var v1 = parseVersion(version);
      var v2 = parseVersion(targetVersion);
      return v1[0] > v2[0] || v1[0] === v2[0] && v1[1] > v2[1] || v1[0] === v2[0] && v1[1] === v2[1] && v1[2] >= v2[2];
    }
  }]);
  return VersionUtils;
}();
function parseVersion() {
  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var v = [0, 0, 0];
  version.split(".").forEach(function (value, i) {
    return v[i] = parseInt(value, 10);
  });
  return v;
}